module.exports = __webpack_public_path__ + "static/media/img-icon-off.54ae7d5a.svg";